import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import { Tooltip } from "@fluentui/react-components";
import { WarningColor } from "@fluentui/react-icons";
import { Duration } from "luxon";
import { useEffect, useState } from "react";

import { useDesktopBridge } from "../../../features/desktop-bridge/use-desktop-bridge.js";
import { usePlatform } from "../../../features/platform-detection/use-platform.js";
import { useLayoutStore } from "../../../store/layout.store.js";

const SIDEBAR_WARNING_GRACE_PERIOD_MS = Duration.fromObject({ minutes: 5 }).as(
  "milliseconds"
);

export const SidebarAppWarning = () => {
  const { isMobileClient } = usePlatform();
  const isMobile = isMobileClient();
  const { status: bridgeStatus } = useDesktopBridge();
  const { modalVariant, hideModal, setModalVariant } = useLayoutStore();
  const [isGracePeriodElapsed, setIsGracePeriodElapsed] = useState(false);

  useEffect(() => {
    if (isMobile) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setIsGracePeriodElapsed(true);
    }, SIDEBAR_WARNING_GRACE_PERIOD_MS);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isMobile]);

  useEffect(() => {
    if (bridgeStatus === "ready" && modalVariant === "sidebar_app_warning") {
      hideModal();
    }
  }, [bridgeStatus, hideModal, modalVariant]);
  const handleClick52 = useStableCallback(() =>
    setModalVariant("sidebar_app_warning")
  );

  if (isMobile || !isGracePeriodElapsed || bridgeStatus === "ready") {
    return null;
  }

  return (
    <Tooltip
      content="BeZoned Sidebar disconnected"
      positioning="after"
      relationship="label"
    >
      <button
        className="group text-bzd-yellow-500 focus-visible:ring-bzd-yellow-200 relative isolate inline-flex items-center justify-center transition-transform duration-200 ease-out hover:scale-110 focus-visible:scale-110 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none"
        onClick={handleClick52}
        type="button"
      >
        <span
          aria-hidden="true"
          className="bg-bzd-yellow-500/75 motion-safe:animate-sidebar-warning-pulse pointer-events-none absolute inset-0 rounded-full blur-md group-hover:[animation-play-state:paused]"
        />
        <span className="relative z-10 inline-flex size-10 items-center justify-center">
          <WarningColor className="size-10 drop-shadow-[0_0_6px_var(--color-bzd-yellow-500)] transition-[filter,transform] duration-200 ease-out group-hover:drop-shadow-[0_0_8px_var(--color-bzd-yellow-500)]" />
          <span
            aria-hidden="true"
            className="motion-safe:animate-sidebar-warning-overlay-pulse pointer-events-none absolute inset-0 z-20 bg-white/20 mix-blend-screen group-hover:[animation-play-state:paused]"
          />
        </span>
      </button>
    </Tooltip>
  );
};
